import ThemeMixin from '@/mixins/templates/theme';

export default {
  mixins   : [ThemeMixin],
  computed : {
    currentImage() {
      return this.isDark
        ? require('@/assets/img/content-sync/empty-associated-dark.svg')
        : require('@/assets/img/content-sync/empty-associated-light.svg');
    }
  }
};
